export default __webpack_public_path__ + "static/media/tomatoPlant_x768.33014263.png";